var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,{"onClick":_vm.onClick,"disabled":_vm.submit}),_c('modal-reassign',{attrs:{"show":_vm.show,"disabled":_vm.submit,"phone-numbers":[_vm.room.phone_number]},on:{"update:show":function($event){_vm.show=$event},"select":_vm.select}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }